import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Toast, ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';
import { MyErrorStateMatcher } from '../bharatbillpay/electricity/electricity.component';
import { RechargeService } from '../services/recharge.service';

@Component({
  selector: 'app-dth-recharge',
  templateUrl: './dth-recharge.component.html',
  styleUrls: ['./dth-recharge.component.scss']
})
export class DthRechargeComponent implements OnInit {
  dthRechargeForm: FormGroup;
  dthsubmitted = false;
  isloading: boolean;
  dthOperatorsList: any;
  commonlocationList: any;
  userCurrenPosition: any;
  opsmsg: string;
  msgdivshow = false;
  rechargeInfo: any;
  matcher = new MyErrorStateMatcher();
  noteData: any;
  isServiceInactive: boolean=false;
  serviceData: any;
  @ViewChild("serviceModal") modalContent: TemplateRef<any>;
  constructor(
    private formBuilder: FormBuilder,
    private rservice: RechargeService,
    private modalService: NgbModal,
    config: NgbModalConfig, 
    private authService: AuthService,
    private router:Router,
    private ngxService: NgxUiLoaderService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private toast:ToastrService

  ) { 
    config.backdrop = 'static';
    config.keyboard = false;
   
    this.dthRechargeForm = this.formBuilder.group({
      customer_Id: ['', Validators.required],
      dthoperator: ['', Validators.required],
      dthrechargeamount: ['', Validators.required],
    });
    this.dthOperators();

    this.dthRechargeForm.get('customer_Id').valueChanges.subscribe((no) => {
      this.msgdivshow = true;
      let selecteddthOperator = this.dthRechargeForm.value.dthoperator;
      switch(selecteddthOperator){
        case 'TATA SKY':{
          this.opsmsg = 'TATA SKY : Subscriber ID starts with 1 and is 10 digits long.'  
          break;
        };
        case 'SUN DIRECT': {
          this.opsmsg = 'SUN DIRECT : Smart card number starts with 1 or 4 and is 11 digits long'  
          break;
        };
        case 'DISH TV DTH': {
          this.opsmsg = 'DISH TV DTH : Viewing card (VC) number starts with 0 and is 11 digits long.'  
          break;
        };
        case 'Airtel TV DTH': {
          this.opsmsg = 'Airtel TV DTH : Customer ID starts with 3 and is 10 digits long.'  
          break;
        };
        case 'Videocon D2H': {
          this.opsmsg = 'Videocon D2H : To know your Customer ID SMS 9212012299  from your registered mobile no.'  
          break;
        };
        case 'SUN DIRECT': {
          this.opsmsg = 'SUN DIRECT : Smart card number starts with 1 or 4 and is 11 digits long.'  
          break;
        };
      }
    })

    this.getLocationDetails();

  }
  get d() { return this.dthRechargeForm.controls; }

  ngOnInit(): void {

    this.locationList();
    this.getactiveAlert();
    
    this.getServiceAlert();

  }


  getServiceAlert(){
    
    this.authService.getserviceAlert('JRI_DTH_RECHARGE').subscribe((res: any) => {
      if (res.status_code == 1 ) {
          // res.object;
      } else {

        this.isServiceInactive=true;
        this.serviceData=res.error;
        this.modalService.open(this.modalContent);

        // this.toast.error(res.error.message);

      }
    }, errData => {
      this.ngxService.stop()
    })
  }
  getactiveAlert(){
    
    this.authService.getactiveAlert('JRI_DTH_RECHARGE').subscribe((res: any) => {
      if (res.status_code == 1) {
          this.noteData=res.object;
      } else {
        // this.toast.error(res.error.message);

      }
    }, errData => {
      this.ngxService.stop()
    })
  } 
  locationList() {
    this.rservice.getAllLocations().subscribe((locationList: any) => {
      this.commonlocationList = locationList.object;
    })
  }

  getLocationDetails(){    
    if (navigator.geolocation) {
      let _this = this
      navigator.geolocation.getCurrentPosition(function(postion){
        _this.userCurrenPosition = postion;
      });
    }
  }
  dthOperators() {
    this.rservice.getdthOperators().subscribe((dthOperators: any) => {
      this.dthOperatorsList = dthOperators.object;
    });
  }
  
  dthRecharge(confirmationModal) {
    if (this.dthRechargeForm.invalid) {
      return;
    } 
     
      this.modalService.open(confirmationModal);
      
    
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  close(content) {
    this.modalService.dismissAll(content);
    }
  closeFinal(finalModal){
    this.modalService.dismissAll(finalModal);
    this.router.navigate(['/dashboard']);

  }
  closeServiceModal(serviceModal){
    this.modalService.dismissAll(serviceModal);
    this.router.navigate(['/dashboard']);

  }
  closeServiceModalOut(serviceModal){
    this.modalService.dismissAll(serviceModal);
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  dthRechargeNow(confirmationModal,finalModal){
    if(this.userCurrenPosition==undefined){
      alert("Please enable your location before proceed, then reload the page for successful transaction");
      return;
 
    }

    this.spinner.show();

    
    let msgparams ={
      number: this.dthRechargeForm.value.customer_Id,
      amount: this.dthRechargeForm.value.dthrechargeamount,
      operator: this.dthRechargeForm.value.dthoperator,
    }
          this.rservice.rechargeDTH(this.dthRechargeForm.value,this.userCurrenPosition?.coords).subscribe((data: any) => {
            if (data.status_code == 1) {
              this.close(confirmationModal);
              this.rechargeInfo=data.object;
              this.modalService.open(finalModal);
              
            } else{
              this.toast.error(data.error.message);
              this.modalService.dismissAll();
            }
            this.spinner.hide();
          }, (err) => {
            this.spinner.hide();

          });
        } 
      
    
    


}
